<div class="confirm-dialog">
  <h2 class="dialog-title">{{ data.title }}</h2>
  <hr class="dialog-divider">

  <div class="dialog-content">
    <div class="warning-container">
      <svg class="warning-icon" width="40" height="40" viewBox="0 0 24 24">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z" fill="#e53935"/>
      </svg>
    </div>
    <p class="dialog-message">{{ data.message }}</p>
  </div>

  <div class="dialog-actions">
    <button class="cancel-button" mat-dialog-close>{{ data.cancelButtonText }}</button>
    <button class="delete-button" [mat-dialog-close]="true">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
        <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/>
      </svg>
      {{ data.confirmButtonText }}
    </button>
  </div>
</div>
